import React from 'react';
import {NavLink} from 'react-router-dom';

const NavLinkButton = ({disabled, children, ...rest}) => {
  return disabled ? children : (
    <NavLink {...rest}>{children}</NavLink>
  );
};

export default NavLinkButton;